import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import {
  IOrganisationSetting,
  IOrganisationSettingSearch,
} from '../interfaces/organisation-setting';
import { OrganisationSettingEnum } from '../enums/organisation-settings';

@Injectable({ providedIn: 'root' })
export class OrganisationSettingService extends BaseDataService {
  url = '/api/organisationSetting';
  entityTitle = 'OrganisationSetting';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public search(filters: IOrganisationSettingSearch): Promise<IOrganisationSetting[]> {
    const queryString = Object.keys(filters)
      .map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(filters[key]);
      })
      .join('&');

    return this.http.get<IOrganisationSetting[]>(`${this.url}s?${queryString}`).toPromise();
  }

  public getSetting(setting: OrganisationSettingEnum): Promise<IOrganisationSetting[]> {
    return this.http.get<IOrganisationSetting[]>(`${this.url}/${setting}`).toPromise();
  }

  patch(id: any, newPatch: any) {
    return this.http.patch<IOrganisationSetting[]>(this.url + '/' + id, newPatch).toPromise();
  }

  create(f) {
    return this.http.post<IOrganisationSetting>(this.url, f).toPromise();
  }

  delete(id: number) {
    return this.http.delete(this.url + '/' + id).toPromise();
  }

  parseSettings(settings: IOrganisationSetting[]) {
    let x: {} = {};

    settings.forEach((y) => {
      x[y.setting] = y;
    });

    return x;
  }
}
